import React from 'react';
import { GENDERS, Gender } from '../pages/NewPatient';
import { Radio } from 'antd';
import { getErrorComp } from './PatientPhoneAutoSuggest';

const GenderBlock: React.FC<{
    isGenderInputDisabled: boolean;
    isGenderError: boolean;
    onGenderChange: (gender: Gender) => void;
    gender: Gender | undefined | string;
    isModal: boolean;
}> = ({ gender, isGenderError, isGenderInputDisabled, onGenderChange, isModal }) => {
    return !isModal ? (
        <div className="w-33p">
            <div className="space-y-4">
                <div className="flex justify-between">
                    <p className="text-neutral-3 font-700 text-14">
                        Gender<span> *</span>
                    </p>
                    {isGenderInputDisabled && (
                        <span className="text-12 self-end mb-2 text-status-error select-none">
                            (can not be edited)
                        </span>
                    )}
                </div>
                <div className="flex space-x-12">
                    {GENDERS.map((g) => (
                        <button
                            key={g}
                            tabIndex={0}
                            onClick={() => onGenderChange(g)}
                            className={`text-14 font-700 inline-flex items-center rounded-24 px-16 py-6 focus:border-neutral-black focus:outline-none ${
                                gender?.toLowerCase() === g?.toLowerCase()
                                    ? ' text-white bg-neutral-black'
                                    : ' border text-neutral-5 border-neutral-5'
                            }`}
                            disabled={isGenderInputDisabled}
                        >
                            {g}
                        </button>
                    ))}
                </div>
            </div>

            <div className="w-33p mt-4">{isGenderError && getErrorComp('Gender is required')}</div>
        </div>
    ) : (
        <div>
            <div className="flex space-x-12 py-8 px-16 bg-darwin-neutral-50 rounded-4">
                {GENDERS.map((g) => (
                    <Radio
                        key={g}
                        value={g}
                        onClick={() => onGenderChange(g)}
                        className="add-new-pt-radio select-none"
                        checked={g === gender}
                        disabled={isGenderInputDisabled}
                    >
                        {g}
                    </Radio>
                ))}
            </div>

            <div className="mt-8">{isGenderError && getErrorComp('Gender is required')}</div>
        </div>
    );
};

export default GenderBlock;
